// @flow
import * as React from 'react';
import { Link } from "react-router-dom";
export var SeoHeaderImage = function () {
  if (window.layoutSettings.layout.images.header === '') {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "clear"
  }), /*#__PURE__*/React.createElement("div", {
    className: "prodwidth center frameless l-container h-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-100 tablet-grid-100 mobile-grid-100 h-pos-relative"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, /*#__PURE__*/React.createElement("img", {
    src: window.layoutSettings.layout.images.header,
    alt: "",
    className: "c-seo-image"
  })))));
};